var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsArray, IsDateString, IsEnum, IsNumber, IsOptional, IsString, IsUUID, } from 'class-validator';
import { TreatmentLocation } from '../../calls/enums/treatment-location.enum.js';
export class UpdateAppointmentDto {
    scheduledStart;
    plannedDuration;
    service;
    description;
    roomId;
    deviceIds;
    therapistId;
    treatmentLocation;
}
__decorate([
    IsDateString(),
    IsOptional(),
    __metadata("design:type", Date)
], UpdateAppointmentDto.prototype, "scheduledStart", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], UpdateAppointmentDto.prototype, "plannedDuration", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateAppointmentDto.prototype, "service", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateAppointmentDto.prototype, "description", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateAppointmentDto.prototype, "roomId", void 0);
__decorate([
    IsArray(),
    IsUUID('4', { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], UpdateAppointmentDto.prototype, "deviceIds", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateAppointmentDto.prototype, "therapistId", void 0);
__decorate([
    IsEnum(TreatmentLocation),
    IsOptional(),
    __metadata("design:type", String)
], UpdateAppointmentDto.prototype, "treatmentLocation", void 0);
//# sourceMappingURL=update-appointment.dto.js.map